import http from "../../utils/httpClient"

class discountSummaryService {

  createOrUpdateDiscountSummary = async (data) => {
    return await http.post("/api/Discount/AddOrEditDiscountSummary", data)
  }

  getDiscountSummary = async () => {
    return await http.get("/api/Discount/GetAllDiscountSummary?getAll=Y")
  }
}
export default new discountSummaryService()
